import TabPage from "./../factories/tab-page";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaseStartModule from "./../factories/base-start-module";
class StartViewModel {
    constructor(tabPage: TabPage) {
        this.TabPage = tabPage;
    }
    StartModuleCollection = ko.observableArray<any>();
    TabPage: TabPage;
    RefreshStart() {
        var deferreds = [];
        for (var i = 0; i < this.StartModuleCollection().length; i++) {
            var startModule = this.StartModuleCollection()[i];
            deferreds.push(startModule.Refresh());
        }
        return $.when.apply(this, deferreds);
    }
    ;
    init() {
        return Bao.post("StartModule/GetStartModules", (result) => {
            var modules = [];
            if (result.length != 0) {
                for (var i = 0; i < result.length; i++) {
                    var newBaseModule = new BaseStartModule(result[i], this.TabPage);
                    modules.push(newBaseModule);
                }
                this.StartModuleCollection(modules);
            }
            else {
                this.TabPage.$TabController.RemoveTab(this.TabPage);
            }
        });
    }
}
export default StartViewModel;